module.exports = __webpack_public_path__ + "static/media/Ground floor plan_page-0001 (1).65ff8564.jpg";